export default "__VITE_ASSET__Sho0l_zM__"